import type { ValidationSchema } from '@wix/editor-elements-corvid-utils';
import { reportError } from '@wix/editor-elements-corvid-utils';

export const indexShouldBePresentInItems = (index: number, length: number) => {
  if (index < 0 || index >= length) {
    reportError(
      `Slideshow items array doesn't contain an item at index ${index}`,
    );
    return false;
  }
  return true;
};

export const validationSchema: ValidationSchema = {
  type: ['object'],
  properties: {
    changeSlide: {
      type: ['function'],
      args: [{ type: ['number'] }],
    },
    previous: {
      type: ['function'],
      args: [],
    },
    next: {
      type: ['function'],
      args: [],
    },
    onChange: {
      type: ['function'],
      args: [{ type: ['function'] }],
    },
    play: {
      type: ['function'],
      args: [],
    },
    pause: {
      type: ['function'],
      args: [],
    },
    onPlay: {
      type: ['function'],
      args: [{ type: ['function'] }],
    },
    onPause: {
      type: ['function'],
      args: [{ type: ['function'] }],
    },
  },
};
